import { useState } from 'react'
import { useCloseModal, useConfigureModalController, useModalController } from '@/atoms'

type ModalStatus = 'ready'

interface ModalData {
  roadSegmentIds: string[]
}

type ModalProps = {
  roadSegments: string[]
}

export const modalId = 'deleteRoadSegment'
export const useController = () => useModalController<ModalData, ModalStatus>(modalId)

export const useConfigureController = ({ roadSegments }: ModalProps) => {
  const close = useCloseModal()

  const [options] = useState(() => ({
    createInitialState: () => ({
      status: 'ready' as ModalStatus,
      data: { roadSegmentIds: roadSegments },
      close,
    }),
  }))

  return useConfigureModalController<ModalData, ModalStatus>(modalId, options)
}
